import { useEffect, useRef, useState } from "react"
import useStore from "components/ui/Context"
import Link from "next/link"
import VlinePlayer from "components/VlinePlayer"
import { uuid } from "uuidv4"
import { notification } from "components/ui"
import { apiPayment } from "api"

const KEY = {
  SW_ERROR_LINK: 500,
  NOT_LOGIN: 400,
  NOT_TICKET: 402,
  MAX_DEVICES: 411,
  TOKEN_INVALID: 401,
  BLOCK_USER: 403,
  EVENT_FINISH: 300,
  EVENT_UPCOMING: 301,
  USER_USING_VPN: "user using VPN"
}

function ViewPlay({ initVideo, isChartOn = true, onEnded, isEmbed = false }) {
  const {
    name,
    thumbnail,
    url,
    is_live,
    is_protected,
    start_time,
    content_id,
    type,
    league_id,
    id,
    status,
    skip_ads,
    error
  } = initVideo

  const { userInfo, logOut, toggleModalLogin } = useStore()
  const isLogin = !!userInfo?.fullname
  const [infoVideo, setInfoVideo] = useState({
    signKey: false,
    errorCode: null,
    time_interval: 30
  })
  const [loading, setLoading] = useState(true)
  const [countViews, setCountViews] = useState(0)
  const indexLink = useRef(0)
  const isError = useRef(0)
  const device_id = useRef()
  const client = useRef()
  const __timeOut = useRef()

  async function checkView() {
    try {
      // await apiSubscription.checkView({ exp: infoVideo?.time_interval || 30 })
    } catch (error) {
      console.log(error)
    }
  }

  async function getSignKey() {
    if (status === "finish") return

    try {
      if (is_live) {
        const { data } = isEmbed
          ? await apiPayment.getSignKeyLiveEmbed({
              match_id: league_id,
              type,
              content_id
            })
          : await apiPayment.getSignKeyLive({
              match_id: league_id,
              type,
              content_id
            })
        setInfoVideo({ signKey: data?.sign_key, time_interval: data?.time_interval })
      } else {
        const { data } = isEmbed
          ? await apiPayment.getSignKeyLiveEmbed({
              match_id: id,
              type,
              content_id,
              is_showpayment: true
            })
          : await apiPayment.getSignKeyVOD({ vod_id: id })
        setInfoVideo({ signKey: data })
      }
    } catch (e) {
      let er
      if (e?.response?.status === KEY.NOT_TICKET) er = KEY.NOT_TICKET
      if (e?.response?.status === KEY.MAX_DEVICES) er = KEY.MAX_DEVICES
      if (e?.response?.status === KEY.BLOCK_USER) er = KEY.BLOCK_USER
      if (e?.response?.status === KEY.TOKEN_INVALID) {
        er = KEY.TOKEN_INVALID
        logOut()
      }
      if (e?.response?.data?.error_message[0] === "Missing authorization token") er = KEY.NOT_LOGIN
      setInfoVideo((s) => ({ ...s, signKey: false, errorCode: er }))
    } finally {
      setLoading(false)
    }
  }

  const handleError = (err) => {
    const { errorCode, errorMessage } = err
    if (errorCode === 410) {
      notification.warning({ message: "Bạn vui lòng tắt chặn quảng cáo để trải nghiệm dịch vụ" })
      return
    }
    if (KEY.USER_USING_VPN === errorCode && id) {
      setInfoVideo((s) => ({ ...s, errorCode: KEY.USER_USING_VPN }))
      return
    }
    if (KEY.SW_ERROR_LINK === errorCode && id) {
      setInfoVideo((s) => ({ ...s, errorCode: KEY.SW_ERROR_LINK }))
      return
    }
    if (errorCode === KEY.TOKEN_INVALID) {
      if (isError.current < 3) {
        isError.current += 1
        getSignKey()
      }
    }
  }

  useEffect(() => {
    getSignKey()

    return () => {
      setInfoVideo({
        signKey: false,
        errorCode: null,
        time_interval: 30
      })
    }
  }, [id, userInfo])

  useEffect(() => {
    if (isLogin && infoVideo?.time_interval) {
      __timeOut.current = setInterval(() => {
        checkView()
      }, infoVideo?.time_interval * 1000)
    }
  }, [userInfo])

  useEffect(() => {
    device_id.current = "w-" + uuid()
    if (initVideo?.id) {
      if (status === "finish") {
        setLoading(false)
        setInfoVideo((s) => ({ signKey: false, errorCode: KEY.EVENT_FINISH }))
      } else if (status === "not_started") {
        setLoading(false)
        setInfoVideo((s) => ({ signKey: false, errorCode: KEY.EVENT_UPCOMING }))
      } else if (is_protected) {
        if (!isLogin) {
          setInfoVideo((s) => ({
            signKey: false,
            errorCode: KEY.NOT_LOGIN,
            errorMessage: "Missing authorization token"
          }))
          setLoading(false)
        }
      } else {
        setInfoVideo((s) => ({ ...s, signKey: false }))
        setLoading(false)
      }
    } else setInfoVideo((s) => ({ signKey: false, errorCode: KEY.SW_ERROR_LINK }))

    indexLink.current = 0
  }, [initVideo])

  useEffect(() => {
    if (error?.error_code) setLoading(false)
  }, [error])

  useEffect(() => {
    return () => {
      clearInterval(__timeOut.current)
      __timeOut.current = null
      if (client.current) {
        client.current.unsubscribe(`eventwatch/${initVideo?.id}`)
        client.current.end(true)
      }
    }
  }, [])

  const { errorCode, signKey } = infoVideo

  const errorMessages = {
    [KEY.MAX_DEVICES]:
      "Bạn đã vượt quá giới hạn thiết bị cho phép xem kênh này. Vui lòng tắt kênh đang xem ở các thiết bị khác để tiếp tục",
    [KEY.EVENT_FINISH]: "Sự kiện đã kết thúc. Mời quay lại và thưởng thức những nội dung hấp dẫn khác",
    [KEY.EVENT_UPCOMING]: "Sự kiện chưa diễn ra. Mời quay lại và thưởng thức những nội dung hấp dẫn khác",
    [KEY.NOT_TICKET]: "Mua gói cước để có thể thưởng thức trọn vẹn nội dung",
    [KEY.NOT_LOGIN]: "Vui lòng đăng nhập để xem nội dung này",
    [KEY.SW_ERROR_LINK]: "Hệ thống đang gián đoạn. Mời quay lại và thưởng thức những nội dung hấp dẫn khác",
    [KEY.USER_USING_VPN]:
      "Nội dung hiện chỉ cung cấp trên lãnh thổ Việt Nam. Vui lòng liên hệ với tổng đài 19001515 để được hỗ trợ",
    [KEY.TOKEN_INVALID]: "Phiên đăng nhập đã hết hạn xin vui lòng đăng nhập lại",
    [KEY.BLOCK_USER]:
      "Tài khoản của bạn đã vi phạm chính sách về bảo vệ bản quyền. Vui lòng liên hệ với tổng đài 19001515 để được hỗ trợ"
  }

  const errorActions = {
    [KEY.TOKEN_INVALID]: { href: `/`, text: "Đăng nhập", toggleModalLogin: toggleModalLogin },
    [KEY.BLOCK_USER]: { href: "/", text: "Về trang chủ" },
    [KEY.NOT_TICKET]: { href: `/subscription?id=${league_id}`, text: "Mua gói cước" },
    [KEY.EVENT_FINISH]: { href: "/", text: "Về trang chủ" },
    [KEY.EVENT_UPCOMING]: { href: "/", text: "Về trang chủ" },
    [KEY.SW_ERROR_LINK]: { href: "/", text: "Về trang chủ" },
    [KEY.NOT_LOGIN]: { href: `/`, text: "Đăng nhập", toggleModalLogin: toggleModalLogin },
    [KEY.MAX_DEVICES]: { href: "/", text: "Đã hiểu" },
    [KEY.USER_USING_VPN]: { href: "/", text: "Về trang chủ" }
  }

  if (!signKey)
    return (
      <div id="container" className="relative w-full aspect-video">
        {infoVideo?.errorCode && id && !loading && (
          <div className="modal__player">
            <div className="text-center px-0 max-sm:min-w-[100vw] max-sm:w-full flex flex-col">
              <ErrorMessage message={errorMessages[errorCode]} />
              {errorActions[errorCode] && (
                <ActionButton
                  href={errorActions[errorCode].href}
                  text={errorActions[errorCode].text}
                  toggleModalLogin={errorActions[errorCode].toggleModalLogin}
                />
              )}
            </div>
          </div>
        )}

        {infoVideo?.errorCode && !id && !loading && (
          <div className="modal__player">
            <div className="text-center px-0 max-sm:min-w-[100vw] max-sm:w-full flex flex-col">
              <ErrorMessage message="Sự kiện đã kết thúc. Mời quay lại và thưởng thức những nội dung hấp dẫn khác." />
              <ActionButton href="/" text="Về trang chủ" />
            </div>
          </div>
        )}

        {!id && !loading && (
          <div className="modal__player">
            <div className="text-center px-0 max-sm:min-w-[100vw] max-sm:w-full flex flex-col">
              <ErrorMessage message="Hệ thống đang gián đoạn. Mời quay lại và thưởng thức những nội dung hấp dẫn khác." />
              <ActionButton href="/" text="Về trang chủ" />
            </div>
          </div>
        )}

        <div className="absolute top-0 left-0 w-full h-full">
          <img src={thumbnail} alt={name} className="w-full h-full object-cover" />
        </div>
      </div>
    )

  return (
    <VlinePlayer
      signKey={signKey}
      contentId={content_id}
      src={is_live ? url : mapParamsToUrl(url, signKey)}
      posterUrl={thumbnail}
      isProtected={is_protected}
      isLive={is_live}
      startTime={start_time}
      name={name}
      id={id}
      type={type}
      skip_ads={skip_ads}
      handleError={handleError}
      countViews={countViews}
      isChartOn={isChartOn}
      onEnded={onEnded}
    >
      {infoVideo?.errorCode && id && !loading && (
        <div className="modal__player">
          <div className="text-center px-0 max-sm:min-w-[100vw] max-sm:w-full flex flex-col">
            <ErrorMessage message={errorMessages[errorCode]} />
            {errorActions[errorCode] && (
              <ActionButton
                href={errorActions[errorCode].href}
                text={errorActions[errorCode].text}
                toggleModalLogin={errorActions[errorCode].toggleModalLogin}
              />
            )}
          </div>
        </div>
      )}

      {infoVideo?.errorCode && !id && !loading && (
        <div className="modal__player">
          <div className="text-center px-0 max-sm:min-w-[100vw] max-sm:w-full flex flex-col">
            <ErrorMessage message="Sự kiện đã kết thúc. Mời quay lại và thưởng thức những nội dung hấp dẫn khác." />
            <ActionButton href="/" text="Về trang chủ" />
          </div>
        </div>
      )}

      <div className="absolute top-0 left-0 w-full h-full">
        <img src={thumbnail} alt={name} className="w-full h-full object-cover" />
      </div>
    </VlinePlayer>
  )
}

export default ViewPlay

const ErrorMessage = ({ message }) => <div className="pb-3 text-base text-[#F4F4F8] text-medium">{message}</div>

const ActionButton = ({ href, text, toggleModalLogin = false }) =>
  toggleModalLogin ? (
    <div className="flex items-center justify-center cursor-pointer">
      <div className="px-6 text-sm py-1.5 rounded-xl bg-primary" onClick={toggleModalLogin}>
        {text}
      </div>
    </div>
  ) : (
    <Link href={href} className="flex items-center justify-center">
      <div className="px-6 text-sm py-1.5 rounded-xl bg-primary">{text}</div>
    </Link>
  )

function mapParamsToUrl(url, params) {
  if (!params) return url
  const query = `${params.expires}/${params.secure}/${params.rand}`
  const parts = url.split("/prod")
  return `${parts[0]}/${query}/prod${parts[1]}`
}
